import { FC } from "react";
import { Box, Typography } from "@material-ui/core";
import { useIntl } from "../../../../../../_metronic/i18n/customUseIntl";
import { roiCalculatorStyles } from "../../../../../ThemeProvider";
import ReactHookDsmInput from "../../../../../modules/Helpers/ReactHookDsmInput2";

interface SolutionCostsSectionProps {
  messageIds: { title: string; description: string; label: string };
  readOnly: boolean;
}

const SolutionCostsSection: FC<SolutionCostsSectionProps> = ({
  messageIds,
  readOnly,
}) => {
  const intl = useIntl();
  const roiClasses = roiCalculatorStyles();

  return (
    <Box className={roiClasses.sectionColumn}>
      <Box className={roiClasses.sectionHeader}>
        <Typography variant="h6" className={roiClasses.sectionTitle}>
          {intl.formatMessage({ id: messageIds.title })}
        </Typography>
        <Typography variant="body2" className={roiClasses.sectionDescription}>
          {intl.formatMessage({ id: messageIds.description })}
        </Typography>
      </Box>

      <div className={roiClasses.splitColumnsContainer}>
        <div className={roiClasses.splitColumn} />

        <Box className={roiClasses.splitColumn}>
          <Typography variant="subtitle1" className={roiClasses.stageSubtitle}>
            {intl.formatMessage({
              id: "SUSTELL.ROI.SOLUTION_COSTS.INTERVENTION_HEADER",
            })}
          </Typography>
          <ReactHookDsmInput
            name="inclusionCostOfSolution"
            label={intl.formatMessage({ id: messageIds.label })}
            adornment={intl.formatMessage({
              id: "SUSTELL.ROI.BASELINE_COSTS.INCLUSION_COST.PLACEHOLDER",
            })}
            type="number"
            required
            disabled={readOnly}
          />
        </Box>
      </div>
    </Box>
  );
};

export default SolutionCostsSection;
